import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useAdminDonationDetail(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDonationDetail = useCallback(async () => {
    setLoading(true);

    try {
      const { response, data } = await API.admin.fetchDonation(token, id);

      if (response.ok) {
        setResult(data);
        setError(null);
      } else {
        setResult(null);
        setError(data.message);
      }
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchDonationDetail();
  }, [token, id]);

  return {
    loading,
    error,
    donation: result,
    reload: fetchDonationDetail,
  };
}
